import { render, staticRenderFns } from "./subsuccess.vue?vue&type=template&id=f1439a84&scoped=true&"
import script from "./subsuccess.vue?vue&type=script&lang=js&"
export * from "./subsuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1439a84",
  null
  
)

export default component.exports